<template>
  <div class="form-group" v-bind:class="{ 'has-error': error }">
    <label v-if="label" :for="name">{{ label }}</label>
    <select type="text"
            @change="updateValue($event.target.value)"
            :name="name"
            :required="required"
            class="form-control"
    >
      <option v-if="placeholder" value="">{{ placeholder }}</option>
      <option v-if="Array.isArray(neighborhoods)"
              v-for="neighborhood in neighborhoods"
              :value="neighborhood.id"
              :selected="value == neighborhood.id"
      >
        {{ neighborhood.name }}
      </option>
    </select>
    <span v-if="error" class="help-block" v-html="error"></span>
  </div>
</template>

<script>
  export default{
    name: 'InputNeighborhoods',
    props: ['name', 'value', 'city', 'required', 'label', 'placeholder', 'error'],
    methods: {
      updateValue (value) {
        // this.cityId = value
        this.$emit('input', value)
      },
      getNeighborhoods () {
        if (this.cityId) {
          return this.$http.get('neighborhoods?city_id=' + this.cityId)
            .then(response => response.data.data, () => false)
        } else {
          return new Promise(() => false, () => false)
        }
      }
    },
    watch: {
      cityId (value) {
        this.neighborhoods = false
        this.neighborhoods = this.getNeighborhoods()
      }
    },
    computed: {
      cityId () {
        return this.city
      }
    },
    asyncComputed: {
      neighborhoods: {
        get () {
          return this.getNeighborhoods()
        },
        default: false
      }
    }
  }
</script>


// WEBPACK FOOTER //
// InputNeighborhoods.vue?5b8ff4e4